import { colors, isPresetColor, isPresetGradientColor, hexToRgba, getColorNameFromSpectrumByLevel } from '@flex-design-system/fx-colors';
import { vars } from '@flex-design-system/ve-presets';
import { getColor } from '../../../../utils/colors.mjs';

function getButtonThemeColor(params) {
  const { color: _color, danger = false, variant } = params;
  const color = danger ? "orange" : _color;
  switch (variant) {
    case "ghost":
    case "outline": {
      const themeColor = isPresetColor(color) ? colors[color] : color;
      if (isPresetGradientColor(color)) {
        return { background: themeColor };
      }
      return { color: themeColor };
    }
    case "solid": {
      return { color: vars.colors.white, background: getColor(color) };
    }
    case "weak": {
      const themeColor = isPresetColor(color) ? colors[color] : color;
      if (isPresetGradientColor(color)) {
        return { color: themeColor };
      }
      const background = hexToRgba(themeColor, 0.07);
      if (!isPresetColor(color)) {
        return { color: vars.colors.grayDarker, background };
      }
      const colorTokenName = getColorNameFromSpectrumByLevel({
        color,
        level: 1
      });
      if (colorTokenName === void 0) {
        return { color: vars.colors.grayDarker, background };
      }
      return {
        color: colors[colorTokenName],
        background: hexToRgba(themeColor, 0.07)
      };
    }
    default: {
      return { color: isPresetColor(color) ? colors[color] : color };
    }
  }
}

export { getButtonThemeColor };
//# sourceMappingURL=getButtonThemeColor.mjs.map
